import qrcode from 'qrcode-generator';

// URL in, dark-module grid out. A pure function, so the thing a phone camera has to read is
// verifiable in a unit test rather than by squinting at a screenshot.
//
// `qrcode-generator` and not a React QR component: it is ~10KB, has no dependencies, and is
// SYNCHRONOUS, which means the view stays a plain render with no effect and no state (INVARIANTS
// rule 6). Every other option in this space renders to a canvas from an effect.
//
// Type number 0 picks the smallest symbol that fits. Error correction M ('medium', ~15%) is the
// usual default and survives a smeared TV panel and a phone held at an angle; H would cost a denser
// symbol for a screen that is not going to be printed, folded or rained on.
export function qrModules(text: string): readonly (readonly boolean[])[] {
  const qr = qrcode(0, 'M');
  qr.addData(text);
  qr.make();
  const size = qr.getModuleCount();
  const rows: boolean[][] = [];
  for (let row = 0; row < size; row++) {
    const cells: boolean[] = [];
    for (let col = 0; col < size; col++) cells.push(qr.isDark(row, col));
    rows.push(cells);
  }
  return rows;
}
